import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';
import BaseWidth from '../../../components/base-width';
import Helmet from 'react-helmet';

const FaqSv = () => (
  <BaseWidth maxWidth={'lg'}>
    <Helmet title={'Svar på vanliga frågor'} />
    <Box pt={5} pb={5}>
      <Typography variant="h2" component="h2" gutterBottom={true}>
        Vanliga frågor och svar
      </Typography>
      <Typography variant="h3" component="h3" gutterBottom={true}>
        Varför finns Världens bibliotek?
      </Typography>
      <Typography gutterBottom={true}>
        Syftet med Världens bibliotek är att främja läsning och kunskap för att
        alla ska kunna verka i samhället på egna villkor. Enligt språklagen ska
        alla människor ges möjlighet att utveckla och använda sitt modersmål. I
        bibliotekslagen står det att de allmänna biblioteken ska erbjuda läsning
        för dig som har ett annat modersmål än svenska. Världens bibliotek är en
        del i arbetet med att tillgodose behovet av böcker på migrantspråk.
        <br /> <br />
        Världens bibliotek är ett digitalt bibliotek för att du ska kunna
        använda biblioteket oavsett var i Sverige du befinner dig.
        <br />
        <br />
      </Typography>
      <Typography variant="h3" component="h3" gutterBottom={true}>
        Vem kan läsa och lyssna på böcker i Världens bibliotek?
      </Typography>
      <Typography gutterBottom={true}>
        Alla som befinner sig fysiskt i Sverige kan använda Världens bibliotek.
        När du går in på www.varldensbibliotek.se görs en kontroll av att du
        befinner dig inom svenskt ip-område. <br />
        <br /> Världens bibliotek finns även i Norge. Den norska motsvarigheten
        heter Verdensbiblioteket och finns på webbsidan{' '}
        <Link
          href="https://www.verdensbiblioteket.no"
          rel="noopener noreferrer"
          target="_blank"
        >
          www.verdensbiblioteket.no
        </Link>
        .
        <br />
        <br />
      </Typography>
      <Typography variant="h3" component="h3" gutterBottom={true}>
        Hur använder jag Världens bibliotek?
      </Typography>
      <Typography gutterBottom={true}>
        Du behöver en mobil, surfplatta eller dator med internetuppkoppling för
        att kunna öppna webbsidan. För att börja läsa och lyssna behöver du
        skapa en användarprofil med din mejladress och logga in. Böckerna
        streamas sedan från webbsidan.
        <br />
        <br />
      </Typography>
      <Typography variant="h3" component="h3" gutterBottom={true}>
        Hur mycket får jag läsa?
      </Typography>
      <Typography gutterBottom={true}>
        Du kan ha 50 böcker i din personliga bokhylla samtidigt. Varje gång du
        börjar läsa en ny bok läggs boken i din personliga bokhylla och finns
        tillgänglig där i 30 dagar. Om du försöker lägga till fler än 50 böcker,
        får du ett felmeddelande. För att kunna öppna en ny bok när du redan har
        50 böcker i din personliga bokhylla, behöver du vänta tills lånetiden
        för någon av dina påbörjade böcker har gått ut.
        <br />
        <br />
      </Typography>
      <Typography variant="h3" component="h3" gutterBottom={true}>
        Varför erbjuder Världens bibliotek böcker på just dessa språk?
      </Typography>
      <Typography gutterBottom={true}>
        Världens biblioteks uppdrag är att erbjuda läsning på de stora
        migrantspråken i Sverige, och på migrantspråk som det kan vara extra
        svårt för läsare i Sverige att hitta böcker på. Världens bibliotek är
        ett komplement till de lokala bibliotekens utbud. Tjänsten utvecklas
        hela tiden vilket innebär att nya språk kan tillkomma med tiden.
        <br />
        <br />
        För att se vilka språk som finns i Världens bibliotek, klicka på “Välj
        bokhylla” på{' '}
        <Link
          href="https://www.varldensbibliotek.se"
          rel="noopener noreferrer"
          target="_blank"
        >
          www.varldensbibliotek.se
        </Link>
        .
        <br />
        <br />
      </Typography>
      <Typography variant="h3" component="h3" gutterBottom={true}>
        Var hittar jag tryckta böcker?
      </Typography>
      <Typography gutterBottom={true}>
        Du hittar tryckta böcker på folkbiblioteken runtom i Sverige. Kontakta
        ditt lokala bibliotek för att få veta vad de har i sitt utbud. De flesta
        lokala bibliotek har både fysiska och digitala böcker. Det finns också
        en stor samling böcker på olika språk hos{' '}
        <Link
          href="https://biblioteket.stockholm.se/artikel/internationella-biblioteket"
          rel="noopener noreferrer"
          target="_blank"
        >
          Internationella biblioteket
        </Link>
        .
        <br />
        <br />
      </Typography>
      <Typography variant="h3" component="h3" gutterBottom={true}>
        Vem arbetar med tjänsten?
      </Typography>
      <Typography gutterBottom={true}>
        Uppdraget att driva Världens bibliotek finns hos Biblioteken i Malmö.
        Teamet som arbetar med tjänsten är utspritt mellan Malmö, Stockholm och
        Oslo. Arbetet regleras av en styrgrupp bestående av ledamöter från
        Kungliga biblioteket, Stockholms stadsbibliotek, norska
        Nasjonalbiblioteket, och Biblioteken i Malmö.
        <br />
        <br />
      </Typography>
      <Typography variant="h3" component="h3" gutterBottom={true}>
        Vem betalar för tjänsten?
      </Typography>
      <Typography gutterBottom={true}>
        Världens bibliotek finansieras av skattepengar. Arbetet drivs och
        bekostas av: <br />
        {'\u2022'}{' '}
        <Link
          href="https://www.kb.se/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Kungliga biblioteket
        </Link>
        , som är Sveriges nationalbibliotek och en statlig myndighet.
        <br />
        {'\u2022'}{' '}
        <Link
          href="https://www.kulturradet.se/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Kulturrådet
        </Link>
        , som är en statlig myndighet med ansvar för att fördela kulturbidrag.
        <br />
        {'\u2022'}{' '}
        <Link
          href="https://www.nb.no/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Nasjonalbiblioteket i Norge
        </Link>
        , som är det norska nationalbiblioteket.
        <br />
        {'\u2022'}{' '}
        <Link href="https://malmo.se" rel="noopener noreferrer" target="_blank">
          Biblioteken i Malmö
        </Link>
        , som är det folkbibliotek som har fått i uppdrag att utveckla och
        förvalta Världens bibliotek.
        <br />
        {'\u2022'}{' '}
        <Link
          href="https://stockholm.se"
          rel="noopener noreferrer"
          target="_blank"
        >
          Stockholms stadsbibliotek
        </Link>
        , som är ett folkbibliotek och deltar som samarbetspartner i arbetet med
        Världens bibliotek.
        <br />
        <br />
      </Typography>
    </Box>
  </BaseWidth>
);

export default FaqSv;
